import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { RoleFormContext } from '../role-form-context';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'tr[app-simple-role-right-tr]',
    templateUrl: './simple-role-right-tr.component.html',
    styleUrls: ['./simple-role-right-tr.component.scss'],
    imports: [MatIconModule, MatCheckboxModule, FormsModule, ReactiveFormsModule]
})
export class SimpleRoleRightTrComponent implements OnInit, OnChanges {
    /**
     * Indique si le formulaire est active
     */
    @Input()
    public disabled: boolean;

    /**
     * Contexte du formulaire (mode d'affichage ...).
     */
    public _context: RoleFormContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<RoleFormContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: RoleFormContext) {
        this._context$.next(value);
    }

    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    @Input()
    public rigthName: string;

    @Input()
    public roleRights: Rights[];

    @Input()
    public rightId: Rights;

    @Output() public checkboxChangedValue: EventEmitter<Rights[]> = new EventEmitter<Rights[]>();

    // Controles
    public rightControl: UntypedFormControl;

    constructor(public enumHelper: EnumHelper) {}

    ngOnInit(): void {
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    ngOnChanges(): void {
        this.rightControl = new UntypedFormControl(null);

        this.rightControl.setValue(this.rightIsActive(this.rightId));
    }

    checkboxChanged(rightId: number, event) {
        if (event.checked) {
            this.roleRights.push(rightId);
        } else {
            this.roleRights = this.roleRights.filter((x) => x !== rightId);
        }

        this.checkboxChangedValue.emit(this.roleRights);
    }

    private rightIsActive(right: Rights): Boolean {
        const isActive = !!this.roleRights?.find((x) => x === right);
        return isActive;
    }
}
